import { __ } from '@wordpress/i18n';
import { FIELD_TYPES } from './fieldTypes';

export const MODAL_OPTIONS = {
  'thumbnail': [
    { id: FIELD_TYPES.IMAGE, icon: 'image', title: __('Single Image', 'havenlytics'), description: __('Add a single thumbnail image', 'havenlytics'), defaultValue: { type: 'single', url: '' } },
    { id: FIELD_TYPES.CAROUSEL, icon: 'images', title: __('Image Carousel', 'havenlytics'), description: __('Add a carousel of images', 'havenlytics'), defaultValue: { type: 'carousel', images: [] } }
  ],
  'top-left': [
    { id: FIELD_TYPES.BADGE, icon: 'tag', title: __('Badge', 'havenlytics'), description: __('Add a badge element', 'havenlytics'), defaultValue: { text: __('Featured', 'havenlytics'), style: 'primary' } }, // Changed to "Featured"
    { id: FIELD_TYPES.STATUS, icon: 'certificate', title: __('Status', 'havenlytics'), description: __('Add a status indicator', 'havenlytics'), defaultValue: { text: __('Active', 'havenlytics'), color: 'green' } },
    { id: FIELD_TYPES.TIME, icon: 'clock', title: __('Time', 'havenlytics'), description: __('Add a time element', 'havenlytics'), defaultValue: { text: __('2 days ago', 'havenlytics') } }
  ],
  'top-right': [
    { id: FIELD_TYPES.FAVORITE, icon: 'heart', title: __('Favorite', 'havenlytics'), description: __('Add a favorite button', 'havenlytics'), defaultValue: { isFavorite: false } },
    { id: FIELD_TYPES.SHARE, icon: 'share-alt', title: __('Share', 'havenlytics'), description: __('Add a share button', 'havenlytics') },
    // { id: FIELD_TYPES.MENU, icon: 'ellipsis-v', title: __('Menu', 'havenlytics'), description: __('Add a options menu', 'havenlytics') }
  ],
  'bottom-left': [
    { id: FIELD_TYPES.BADGE, icon: 'tag', title: __('Badge', 'havenlytics'), description: __('Add a badge element', 'havenlytics'), defaultValue: { text: __('Featured', 'havenlytics'), style: 'primary' } }, // Changed to "Featured"
    { id: FIELD_TYPES.STATUS, icon: 'certificate', title: __('Status', 'havenlytics'), description: __('Add a status indicator', 'havenlytics'), defaultValue: { text: __('Active', 'havenlytics'), color: 'green' } },
    { id: FIELD_TYPES.PRICE, icon: 'dollar-sign', title: __('Property Price', 'havenlytics'), description: __('Add a price element', 'havenlytics'), defaultValue: { value: '1,250,000', currency: 'USD' } },
    { id: FIELD_TYPES.RATING, icon: 'star', title: __('Rating', 'havenlytics'), description: __('Add a rating element', 'havenlytics'), defaultValue: { value: 4.5, max: 5 } },

    { id: FIELD_TYPES.SCHEDULE_TOUR, icon: 'calendar-alt', title: __('Schedule Tour', 'havenlytics'), description: __('Add a schedule tour button', 'havenlytics'), defaultValue: { text: __('Schedule Tour', 'havenlytics'), icon: 'calendar-alt' } }
  ],
  'bottom-right': [
    { id: FIELD_TYPES.VIEWS, icon: 'eye', title: __('Views', 'havenlytics'), description: __('Add a view counter', 'havenlytics'), defaultValue: { count: 0 } },
    { id: FIELD_TYPES.SHARE, icon: 'share-alt', title: __('Share', 'havenlytics'), description: __('Add a share button', 'havenlytics') },
    { id: FIELD_TYPES.FAVORITE, icon: 'heart', title: __('Favorite', 'havenlytics'), description: __('Add a favorite button', 'havenlytics'), defaultValue: { isFavorite: false } },
    { id: FIELD_TYPES.RATING, icon: 'star', title: __('Rating', 'havenlytics'), description: __('Add a rating element', 'havenlytics'), defaultValue: { value: 4.5, max: 5 } }
  ],
  'avatar': [
    { 
      id: 'avatar', 
      icon: 'user-circle', 
      title: __('Avatar', 'havenlytics'), 
      description: __('Add an avatar image', 'havenlytics'), 
      defaultValue: { type: 'avatar', url: '' } 
    }
  ],
  'title': [
    { id: FIELD_TYPES.TITLE, icon: 'heading', title: __('Property Title', 'havenlytics'), description: __('Add a title element', 'havenlytics'), defaultValue: { text: __('Luxury Villa with Ocean View', 'havenlytics') } },
    { id: FIELD_TYPES.PRICE, icon: 'dollar-sign', title: __('Price', 'havenlytics'), description: __('Add property price', 'havenlytics'), defaultValue: { value: '1,250,000', currency: 'USD' } },
    { id: FIELD_TYPES.RATING, icon: 'star', title: __('Property Rating', 'havenlytics'), description: __('Add a rating element', 'havenlytics'), defaultValue: { value: 4.5, max: 5 } },
    { id: FIELD_TYPES.LOCATION, icon: 'map-marker-alt', title: __('Location', 'havenlytics'), description: __('Add property location', 'havenlytics'), defaultValue: { text: __('123 Ocean View Drive, Malibu, CA', 'havenlytics') } }
  ],
  'location': [
    { id: FIELD_TYPES.LOCATION, icon: 'map-marker-alt', title: __('Location', 'havenlytics'), description: __('Add property location', 'havenlytics'), defaultValue: { text: __('123 Ocean View Drive, Malibu, CA', 'havenlytics') } }
  ],
  'excerpt': [
    { id: FIELD_TYPES.EXCERPT, icon: 'align-left', title: __('Excerpt', 'havenlytics'), description: __('Add property excerpt', 'havenlytics'), defaultValue: { text: __('Stunning oceanfront villa with panoramic views, modern amenities, and luxurious finishes. Features include infinity pool, home theater, and smart home technology.', 'havenlytics') } }
  ],
  'features': [
    { id: FIELD_TYPES.BEDS, icon: 'bed', title: __('Beds', 'havenlytics'), description: __('Add number of bedrooms', 'havenlytics'), defaultValue: { value: '3' } },
    { id: FIELD_TYPES.BATHS, icon: 'bath', title: __('Baths', 'havenlytics'), description: __('Add number of bathrooms', 'havenlytics'), defaultValue: { value: '2' } },
    { id: FIELD_TYPES.KITCHENS, icon: 'utensils', title: __('Kitchens', 'havenlytics'), description: __('Add number of kitchens', 'havenlytics'), defaultValue: { value: '1' } },
    { id: FIELD_TYPES.FLOOR, icon: 'layer-group', title: __('Floor', 'havenlytics'), description: __('Add floor number', 'havenlytics'), defaultValue: { value: '1' } },
    { id: FIELD_TYPES.ROOMS, icon: 'door-closed', title: __('Rooms', 'havenlytics'), description: __('Total number of rooms', 'havenlytics'), defaultValue: { value: '1' } },
    { id: FIELD_TYPES.RECEPTIONS, icon: 'door-open', title: __('Receptions', 'havenlytics'), description: __('Add number of reception rooms', 'havenlytics'), defaultValue: { value: '2' } },
    { id: FIELD_TYPES.SQFT, icon: 'expand-arrows-alt', title: __('Square Feet', 'havenlytics'), description: __('Add property square footage', 'havenlytics'), defaultValue: { value: '2,980' } },
    { id: FIELD_TYPES.GSFT, icon: 'warehouse', title: __('Gsq ft', 'havenlytics'), description: __('Add property garage square footage', 'havenlytics'), defaultValue: { value: '50' } }
  ],
  'content': [
    { id: FIELD_TYPES.PHONE, icon: 'phone', title: __('Phone', 'havenlytics'), description: __('Add a phone number', 'havenlytics'), defaultValue: { number: '+1 234 567 8900' } },
    { id: FIELD_TYPES.EMAIL, icon: 'envelope', title: __('Email', 'havenlytics'), description: __('Add an email address', 'havenlytics'), defaultValue: { address: 'contact@example.com' } },
    { id: FIELD_TYPES.WEBSITE, icon: 'globe', title: __('Website', 'havenlytics'), description: __('Add a website link', 'havenlytics'), defaultValue: { url: 'www.example.com' } },
    { id: FIELD_TYPES.ADDRESS, icon: 'map-marker', title: __('Address', 'havenlytics'), description: __('Add a location address', 'havenlytics'), defaultValue: { text: __('123 Main St, City', 'havenlytics') } },
    { id: FIELD_TYPES.DATETIME, icon: 'clock', title: __('Date/Time', 'havenlytics'), description: __('Add a date or time', 'havenlytics'), defaultValue: { text: __('Posted 2 days ago', 'havenlytics') } }
  ],
  'footer-left': [
    { 
      id: FIELD_TYPES.VIEW_BUTTON, 
      icon: 'external-link-alt', 
      title: __('View Property Button', 'havenlytics'), 
      description: __('Add a view property button', 'havenlytics'), 
      defaultValue: { 
        text: __('View Property', 'havenlytics'), 
        style: 'primary',
        type: 'view-property'
      } 
    },
    { 
      id: FIELD_TYPES.SCHEDULE_TOUR_BUTTON, 
      icon: 'calendar-alt', 
      title: __('Schedule Tour Button', 'havenlytics'), 
      description: __('Add a schedule tour button', 'havenlytics'), 
      defaultValue: { 
        text: __('Schedule Tour', 'havenlytics'), 
        style: 'primary',
        type: 'schedule-tour'
      } 
    },
    { 
      id: FIELD_TYPES.BADGE, 
      icon: 'tag', 
      title: __('Badge', 'havenlytics'), 
      description: __('Add a badge element', 'havenlytics'), 
      defaultValue: { text: __('Featured', 'havenlytics'), style: 'secondary' } 
    },
    { 
      id: FIELD_TYPES.STATUS, 
      icon: 'certificate', 
      title: __('Status', 'havenlytics'), 
      description: __('Add a status indicator', 'havenlytics'), 
      defaultValue: { text: __('Active', 'havenlytics'), color: 'green' } 
    },
    { 
      id: FIELD_TYPES.TIME, 
      icon: 'clock', 
      title: __('Time', 'havenlytics'), 
      description: __('Add a time element', 'havenlytics'), 
      defaultValue: { text: __('2 days ago', 'havenlytics') } 
    }
  ],
  'footer-right': [
    { 
      id: FIELD_TYPES.SHARE, 
      icon: 'share-alt', 
      title: __('Share', 'havenlytics'), 
      description: __('Add a share button', 'havenlytics') 
    },
    { 
      id: FIELD_TYPES.FAVORITE, 
      icon: 'heart', 
      title: __('Favorite', 'havenlytics'), 
      description: __('Add a favorite button', 'havenlytics'), 
      defaultValue: { isFavorite: false } 
    },
    { 
      id: FIELD_TYPES.RATING, 
      icon: 'star', 
      title: __('Rating', 'havenlytics'), 
      description: __('Add a rating element', 'havenlytics'), 
      defaultValue: { value: 4.5, max: 5 } 
    },
    { 
      id: FIELD_TYPES.PROPERTY_TYPE, 
      icon: 'home', 
      title: __('Property Type', 'havenlytics'), 
      description: __('Add property type badge', 'havenlytics'), 
      defaultValue: { text: __('Villa', 'havenlytics'), style: 'secondary' } 
    },
    { 
      id: FIELD_TYPES.VIEWS, 
      icon: 'eye', 
      title: __('Views', 'havenlytics'), 
      description: __('Add a view counter', 'havenlytics'), 
      defaultValue: { count: 0 } 
    }
  ],
  'schedule-tour': [
    { id: FIELD_TYPES.SCHEDULE_TOUR, icon: 'mouse-pointer', title: __('Schedule Tour', 'havenlytics'), description: __('Add a schedule tour element', 'havenlytics'), defaultValue: { text: __('Schedule Tour', 'havenlytics'), icon: 'calendar-alt' } }
  ],
};